import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { NgxSpinnerService } from 'ngx-spinner'
import { ExportService } from 'src/app/services/export.service';


interface ZeresimaData {
  comprovante: string,
  tituloEleicao: string,
  nomeGestor: string,
  dataZeresima: string,
  ipZeresima: string
  }

@Component({
  selector: 'app-modal-comprovante-zeresima',
  templateUrl: './modal-comprovante-zeresima.component.html',
  styleUrls: ['./modal-comprovante-zeresima.component.scss']
})

export class ModalComprovanteZeresimaComponent implements OnInit {
  title: string;
  closeBtnName: string;
  header: string;
  zeresimaData: ZeresimaData;
  onSuccess: any;

  constructor(
    public bsModalRef: BsModalRef,
    private exportService: ExportService
  ) { }

  ngOnInit() {
  }

  comprovantePDF(){
    this.exportService.exportPDF('comprovante-zeresima', 'comprovante-zeresima.pdf', 'Comprovante de geração de zerésima');
  }

}
